import { render } from "./Facts.vue?vue&type=template&id=528241f8&scoped=true"
import script from "./Facts.vue?vue&type=script&lang=js"
export * from "./Facts.vue?vue&type=script&lang=js"

import "./Facts.vue?vue&type=style&index=0&id=528241f8&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src319724418/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528241f8"]])

export default __exports__